// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import FlashController from "./flash_controller"
import MemberFormController from "./member_form_controller"
import CookieNoticeController from "./cookie_notice_controller"
import ModalController from "./modal_controller"
import CurrencyController from "./currency_controller"
import DisclosureController from "./disclosure_controller"
import WelcomeModalController from "./welcome_modal_controller"

application.register("hello", HelloController)
application.register("flash", FlashController)
application.register("member-form", MemberFormController)
application.register("cookie-notice", CookieNoticeController)
application.register("modal", ModalController)
application.register("currency", CurrencyController)
application.register("disclosure", DisclosureController)
application.register("welcome-modal", WelcomeModalController)
